import store from "./store";
import VisibilityAwareWebSocket from "./utils/visibilityAwareWebSocket";
// eslint-disable-next-line
let wsUrl = process.env.VUE_APP_WORK_WS + "/";
// eslint-disable-next-line
let env = process.env.VUE_APP_SENTRY_ENV;
// eslint-disable-next-line
let disableSocket = process.env.VUE_APP_DISABLE_SOCKET === "true";

class WorkSocket {
    constructor(channel = undefined) {
        this._socket = undefined;
        this.connected = false;
        this.channel = channel;
        this.errorCount = 0;
        this.isDebug = env === "develop";
        this.disabled = disableSocket;
        if (!this.disabled) this.connect();
    }

    logDebug(...args) {
        if (this.isDebug) {
            console.log(...args);
        }
    }

    connect() {
        if (this.disabled) return;
        const ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
        const ws_path = ws_scheme + "://" + wsUrl;

        this._socket = new VisibilityAwareWebSocket(ws_path);
        this._socket.onopen = () => {
            this.logDebug(`SOCKET CONNECTED to ${ws_path}`);
            this.connected = true;
            this.errorCount = 0; // Reset contatore errori su connessione riuscita
            store.dispatch("socketconnected", true);
        };
        this._socket.onerror = (error) => {
            this.logDebug("SOCKET ERROR", error);
            this.connected = false;
            this.errorCount++;

            // Publish connection state after repeated failures; HTTP actions stay usable.
            if (this.errorCount >= 3) {
                store.dispatch("socketconnected", false).then(() => {});
            }
        };
        this._socket.onclose = () => {
            this.logDebug("SOCKET CLOSED");
            this.connected = false;
            this.errorCount++;

            // Publish connection state after repeated failures; HTTP actions stay usable.
            if (this.errorCount >= 3) {
                store.dispatch("socketconnected", false).then(() => {});
            }
        };
        this._socket.onmessage = ({ data }) => {
            this.logDebug("SOCKET MESSAGE", data);
            if (data) {
                let payload = JSON.parse(data);
                // store payload.channel_name if present
                if (payload.channel_name) {
                    store.dispatch("socketchannel", payload.channel_name).then(() => {});
                }
                store.dispatch("socketmessage", payload).then(() => {});
            }
        };
    }
}

const socket = new WorkSocket(wsUrl);
export default socket;
